import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './UserAvatar.css';

const UserAvatar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleLogout = () => {
    logout();
    navigate('/');
    setDropdownOpen(false);
  };

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  if (!user) return null;

  return (
    <div className="user-avatar-container" ref={dropdownRef}>
      <button
        className="user-avatar-button"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-label="User menu"
      >
        <div className="user-avatar">
          {getInitials(user.name)}
        </div>
      </button>
      {dropdownOpen && (
        <div className="user-dropdown">
          <div className="dropdown-header">
            <div className="dropdown-avatar">{getInitials(user.name)}</div>
            <div className="dropdown-user-info">
              <div className="dropdown-name">{user.name}</div>
              <div className="dropdown-email">{user.email}</div>
            </div>
          </div>
          <div className="dropdown-divider"></div>
          <Link to="/dashboard" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
            Dashboard
          </Link>
          <Link to="/orders" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
            Order History
          </Link>
          <Link to="/messages" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
            Messages
          </Link>
          <Link to="/wallet" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
            Wallet
          </Link>
          {user.isAdmin && (
            <>
              <div className="dropdown-divider"></div>
              <Link to="/admin" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                Admin Panel
              </Link>
              <Link to="/admin/chats" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                Support Chats
              </Link>
              <Link
                to="/admin/membership-plans"
                className="dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                Membership Plans
              </Link>
              <Link to="/admin/wallets" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                Wallet Manager
              </Link>
            </>
          )}
          <div className="dropdown-divider"></div>
          <button className="dropdown-item dropdown-logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
